import { render, staticRenderFns } from "./ProfilesAssociationTable.vue?vue&type=template&id=22816250&scoped=true&"
import script from "./ProfilesAssociationTable.vue?vue&type=script&lang=ts&"
export * from "./ProfilesAssociationTable.vue?vue&type=script&lang=ts&"
import style0 from "./ProfilesAssociationTable.vue?vue&type=style&index=0&id=22816250&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22816250",
  null
  
)

export default component.exports